import React,{useEffect,useState} from 'react';
import './styles/App.css';
import { instance } from './common';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function Pc_Mypagemain({history}) {
    let session = JSON.parse(window.sessionStorage.result);
    console.log('session : ', session)
    let {u_login_id, u_type, u_sigong} = session;
    const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [data, setData] = useState({
      u_nick: '',
      u_phone: '',
      u_email:'',
      u_bank:'',
      u_holder:'',
      u_account:'',
      u_company_num:'',
      u_uuid:'',
  });

  const [sigong, setSigong] = useState({
    si_name:'',
    si_address:''
  })
  const {si_name,si_address} = sigong;
  const {u_nick,u_phone,u_email,u_uuid,u_bank,u_holder,u_account,u_company_num} = data;

  const [pw, setPw] = useState({
      pw1:'',
      pw2:''
  });
  const {pw1,pw2} = pw
  const [pwChk, setPwChk] = useState(false);

  useEffect(() => {
      if(pw1 === pw2){
        setPwChk(true)
      }else{
        setPwChk(false)
      }
  },[pw1,pw2])
  const pwChangeHandler = (e) => {
    const {name,value} = e.target
    setPw({
        ...pw,
        [name]:value
    })
  }

  useEffect(() => {
    instance.post('/common/condition',
    { table:'sigong',common:{si_id: u_sigong} })
        .then(function(res){
            console.log('res: ', res.data[0])
            setSigong({
                si_name:res.data[0].si_name,
                si_address:res.data[0].si_address,
            })
        });
    instance.post('/users/id',
    { u_login_id: u_login_id })
        .then(function(res){
            console.log('res: ', res.data[0])
            setData({
                u_nick:res.data[0].u_nick,
                u_phone:res.data[0].u_phone,
                u_email:res.data[0].u_email,
                u_bank:res.data[0].u_bank,
                u_holder:res.data[0].u_holder,
                u_account:res.data[0].u_account,
                u_company_num:res.data[0].u_company_num,
                u_uuid:res.data[0].u_uuid
            })
        });
  }, []);

    const inputChange = (e) => {
        const {name,value} = e.target;
        setData({
            ...data,
            [name]:value
        })
        
    };

    const modify = () => {
 
        const fetchData = async () => {
            instance.post('/users/update',
            {obj:data, whereField:'u_login_id', whereValue:u_login_id})
            .then(function(res){
                console.log('res : ', res)
                let myInfo = JSON.parse(window.sessionStorage.result);
                myInfo.u_uuid = u_uuid;
                window.sessionStorage.setItem('result', JSON.stringify(myInfo));
                alert('정상적으로 수정되었습니다.');
            });
        
        };
    
        fetchData();
    }

    const uploadImage = (e) => {
        const {id,files} = e.target;
        let file = files[0];
        let dir = u_login_id;

        let formData = new FormData();
        formData.append('dir', dir);
        formData.append('img', file);
        fileUpload(formData,id);
    }

    const fileUpload = (formdata,id) => {
        const fetchData = async () => {
            instance.post('/file/image',formdata,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                  }
            })
            .then(function(res){
                console.log('res : ', res);
                let path = res.data.path;
                path = path.slice(7,path.length)
                let url = 'https://abys-service.co.kr:3001//'+path;
                setData({
                    ...data,
                    u_uuid:url
                })
            });
        
        };
    
        fetchData();
    }

    const changePwd = () => {

        if(pwChk){
            const fetchData = async () => {
                instance.post('/users/update/pwd',
                {u_pwd:pw1,u_login_id:u_login_id})
                .then(function(res){
                    alert('정상적으로 수정되었습니다.');
                    setModal(!modal);
                });
            
            };
        
            fetchData();
        }else{
            alert('비밀번호를 확인해주세요');
        }

    }

  return (
    <>
    <div className="container mb-5">
        <div className="row">
            <div className="col-12 d-inline-block text-center mt-5">
                <div className="my__Top__title font-weight-bold" style={{marginBottom:'60px'}}>마이페이지</div>
                <table className="table my__table">
                    <tr>
                        <td className="td__first__box border-right">
                            프로필 사진
                        </td>
                        <td className="text-left p-5">
                        {
                            u_uuid
                            ?<div className="mypageEdit_img_pc d-inline-block" style={{background:'url(\''+u_uuid+'\')'}}></div>
                            :<div className="mypageEdit_img_pc d-inline-block" ></div>
                        }
                         <label htmlFor="file-upload" className="btn btn-link btn-sm py-2 ml-5 p text-center mpEdit-btn-pc">사진변경</label>
                         <input id="file-upload" type="file" className="d-none" accept="image/png, image/jpeg, image/jpg" onChange={uploadImage}/>
                        </td>
                    </tr>
                    {
                        u_type === '시공지점' &&

                        <>
                        <tr>
                            <td className="td__first__box border-right">
                                대리점명
                            </td>
                            <td className="text-left p-5">
                                {
                                si_name
                                }
                            </td>
                        </tr>
                        <tr>
                            <td className="td__first__box border-right">
                                대리점 주소
                            </td>
                            <td className="text-left p-5">
                                {
                                si_address
                                }
                            </td>
                        </tr>
                        <tr>
                            <td className="td__first__box border-right">
                                사업자등록번호
                            </td>
                            <td className="text-left p-5">
                                <input name="u_company_num" className="mt-2 my__text_input" onChange={inputChange} type="text" value={u_company_num} />
                            </td>
                        </tr>
                        <tr>
                            <td className="td__first__box border-right">
                                입금계좌_은행
                            </td>
                            <td className="text-left p-5">
                                 <input name="u_bank" className="mt-2 my__text_input" onChange={inputChange} type="text" value={u_bank} />
                            </td>
                        </tr>
                        <tr>
                            <td className="td__first__box border-right">
                                계좌
                            </td>
                            <td className="text-left p-5">
                                <input name="u_account" className="mt-2 my__text_input" onChange={inputChange} type="text" value={u_account} />
                            </td>
                        </tr>
                        <tr>
                            <td className="td__first__box border-right">
                                예금주
                            </td>
                            <td className="text-left p-5">
                                <input name="u_holder" className="mt-2 my__text_input" onChange={inputChange} type="text" value={u_holder} />
                            </td>
                        </tr>
                        </>
                    }
                    
                    

                    <tr>
                        <td className="td__first__box border-right">
                            ID
                        </td>
                        <td className="text-left p-5">
                            {u_login_id}
                        </td>
                    </tr>
                    <tr>
                        <td className="td__first__box border-right">
                            성함
                        </td>
                        <td className="text-left p-5">
                            <input name="u_nick" className="mt-2 my__text_input" onChange={inputChange} type="text" value={u_nick} />
                        </td>
                    </tr>
                    <tr>
                        <td className="td__first__box border-right">
                            이메일
                        </td>
                        <td className="text-left p-5">
                            <input name="u_email" className="mt-2 my__text_input" type="text" onChange={inputChange} value={u_email} /> 
                        </td>
                    </tr>
                    <tr>
                        <td className="td__first__box border-right">
                            휴대폰 번호
                        </td>
                        <td className="text-left p-5">
                            <input name="u_phone" className="mt-2 my__text_input" type="text" onChange={inputChange} value={u_phone} /> 
                        </td>
                    </tr>
                    
                </table>
                
            </div>
            <div className="col-12 text-center mt-3">
               
            </div>

            <div className="myEdit_down w-100 text-center">
                <button type="button" className="btn btn-primary myEdit_downbtn_pc" onClick={modify}>저장</button>
            </div>
            <div className="myEdit_down w-100 text-center">
                <button type="button" className="btn btn-primary myEdit_downbtn_pc" onClick={toggle}>비밀번호 변경</button> 
            </div>
            <div className="myEdit_down w-100 text-center">
                <button type="button" className="btn btn-primary myEdit_downbtn_pc" onClick={() => history.push('/')}>홈 으로</button> 
            </div>
        </div>
    </div>
    <div>
         <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>비밀번호 변경</ModalHeader>
                <ModalBody>
                    <div className="col-12 mb-3">
                            <label>비밀번호</label>
                            <input type="password" name="pw1" value={pw1} onChange={pwChangeHandler} className="form-control" placeholder="변경할 비밀번호를 입력해주세요" />
                        </div>
                        <div className="col-12">
                            <label>비밀번호 확인</label>
                            <input type="password" name="pw2" value={pw2} onChange={pwChangeHandler}   className="form-control"  placeholder="같은 비밀번호를 입력해주세요" />
                        </div>
                        {
                            pw1 && pw2 && !pwChk &&  <div className="col-12 mt-3 text-primary"><p>* 비밀번호가 일치 하지 않습니다.</p></div>
                        }
                       
                </ModalBody>
                <ModalFooter>
                <Button color="primary" onClick={changePwd}>비밀번호 수정</Button>{' '}
                <Button color="secondary" onClick={toggle}>취소</Button>
                </ModalFooter>
        </Modal>
    </div>
    </>
  );
}

export default Pc_Mypagemain;